/**
 * 复选框相关
 */
export default {
    data () {
        return {
            customerIds: [], // 客户id集合
            productIds: [], // 货品id集合
            // 暂时借用product的数据
            customerConfig: [{
                    prop: 'customer',
                    label: '客户编码',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_account',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '客户名称',
                    width: 300,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_name',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '联系人',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_contact',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '联系手机',
                    width: 160,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_tel',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
            }],
            // 往来项目
            wanglaiConfig:[{
                prop: 'product',
                label: '往来项目',
                json: {
                    width: '742px',
                    api: 'api/wanglaixm', 
                    prop: 'product_name',
                    fields: [{
                        label: '往来项目',
                        prop: 'product_name',
                        width: 740
                    }]
                },
                component: 'LyAutoSearch'
            }]
        }
    },
    mounted () {                    
    }
}